import NavigationManage from './NavigationManage';
import ManageTheme from './manageTheme/index';
import ManageConfiguration from './manageConfiguration';
import EditTheme from './editTheme';
import EditConfig from './editConfig';
import ManageApps from './apps';
import ManageDomains from './domains';

export { NavigationManage, ManageTheme, EditTheme, ManageConfiguration, EditConfig, ManageApps, ManageDomains };



// WEBPACK FOOTER //
// ./src/components/pages/manage/index.js